var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SwingBySwingApi } from "../services/swingbyswingapi";
import { Club, HttpResponseMessage, ClubType, ClubCollection } from "../lib/types";
var Clubs = /** @class */ (function (_super) {
    __extends(Clubs, _super);
    function Clubs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns all clubs for a player
     */
    Clubs.prototype.getAll = function (playerId) {
        var _this = this;
        if (playerId === void 0) { playerId = "me"; }
        // Get clubs for player
        return this.request("GET", "clubs/" + playerId).then(function (r) {
            return _this.mapResponse(new ClubCollection(), r.data);
        });
    };
    /**
     * Returns a specific club for an authorized player
     *
     * @param clubId The club to get
     */
    Clubs.prototype.getSpecific = function (playerId, clubId) {
        var _this = this;
        if (playerId === void 0) { playerId = "me"; }
        // Get specific club for player
        return this.request("GET", "clubs/" + playerId + "/" + clubId).then(function (r) {
            var mappedResponse;
            if (playerId !== "me") {
                // Get club specific
                r.data.clubs.forEach(function (club) {
                    if (club.clubId == clubId) {
                        mappedResponse = _this.mapResponse(new Club(), club);
                    }
                });
            }
            else {
                mappedResponse = _this.mapResponse(new Club(), r.data);
            }
            // Map club and return the result
            return mappedResponse;
        });
    };
    Clubs.prototype.clubShots = function (playerId, clubId, from, to) {
        if (playerId === void 0) { playerId = "me"; }
        if (from === void 0) { from = 1; }
        if (to === void 0) { to = 20; }
        return this.request("GET", "clubshots/" + playerId, {
            clubId: clubId,
            from: from,
            to: to
        }).then(function (r) {
            return r.data;
        });
    };
    /**
     * Deletes a club for a player
     *
     * @param player The player to delete for
     * @param club   The club to delete
     */
    Clubs.prototype["delete"] = function (clubId) {
        var _this = this;
        // Delete the club
        return this.request("DELETE", "clubs/" + clubId).then(function (r) {
            // Return the mapped response
            return _this.mapResponse(new HttpResponseMessage(), r.data);
        });
    };
    /**
     * Updates a club for an authorized player
     *
     * @param  clubId        The club to update
     * @param  clubName      The updated name
     * @param  clubType      The updated type
     * @param  isActive      The updated visibility
     * @param  averageMeters The updated average meters
     * @param  averageYards  The updated average yards
     * @return void
     */
    Clubs.prototype.update = function (clubId, clubType, clubName, isActive, averageMeters, averageYards) {
        var _this = this;
        // Update the club
        return this.request("PUT", "clubs/" + clubId, {
            clubType: clubType,
            clubName: clubName,
            isActive: isActive,
            averageMeters: averageMeters,
            averageYards: averageYards
        }).then(function (r) {
            // Return the mapped response
            return _this.mapResponse(new Club(), r.data);
        });
    };
    /**
     * Adds a club for a player
     *
     * @param clubName The new club name
     * @param clubType The new club type
     * @param isActive The new club active status
     */
    Clubs.prototype.add = function (clubType, clubName, isActive, averageMeters, averageYards) {
        var _this = this;
        // Add a new club
        return this.request("POST", "clubs", {
            clubType: clubType,
            clubName: clubName,
            isActive: isActive,
            averageMeters: averageMeters,
            averageYards: averageYards
        }).then(function (r) {
            // Return the mapped response
            return _this.mapResponse(new Club(), r.data);
        });
    };
    /**
     * Gets the types of available clubs
     */
    Clubs.prototype.types = function () {
        var _this = this;
        return this.request("GET", "clubtypes").then(function (r) {
            var clubTypes = r.data;
            // Loop through clubtypes and map them
            return clubTypes.map(function (c) {
                // Map club type
                var clubType = _this.mapResponse(new ClubType(), c);
                // Return mapped club types
                return clubType;
            });
        });
    };
    return Clubs;
}(SwingBySwingApi));
export { Clubs };
